module.exports = __webpack_public_path__ + "static/img/sp_mypage.2ffe27a.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/sales/dashboard/assest/images/sp_mypage.png
// module id = vWvI
// module chunks = 0